import { Link } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export default function NotFound() {
  return (
    <>
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-32 text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-red-600 mb-4">404</div>
        <h1 className="font-display font-black uppercase text-5xl text-white mb-6">Page not found</h1>
        <p className="text-slate-400 mb-10">The page you're looking for doesn't exist.</p>
        <Link to="/" data-testid="back-home" className="bg-red-600 text-white font-bold uppercase tracking-wide hover:bg-red-500 px-8 py-4 inline-flex items-center gap-2">
          Back to home
        </Link>
      </main>
      <Footer />
    </>
  );
}
